import api from '@/api';
import * as types from '@/store/types';

const state = {
    data: [],
    meta: {},
    payout: {},
};


const getters = {
    payouts: state => state,
    payoutById: state => id => {
        const payout = state.payout[id];
        return payout || id;
    },
};


const actions = {
    getPayouts ({ commit }, payload) {
        return api.payouts.list(payload).then((response) => {
            commit(types.RECEIVE_PAYOUTS, response.data);
        });
    },
    getPayout ({ commit }, id) {
        return api.payouts.get(id).then((response) => {
            commit(types.RECEIVE_PAYOUT, response.data);
        });
    },
};


const mutations = {
    [types.RECEIVE_PAYOUTS] (state, { data, meta }) {
        state.data = data;
        state.meta = meta;
    },
    [types.RECEIVE_PAYOUT] (state, { data }) {
        if (data && data.id) {
            state.payout[data.id] = data;
            state.payout = Object.assign({}, state.payout);
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
